import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        async FetchAddressesByPostCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/addresses/fetch/postcode`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchAddressesByPostCode: ${error.message}`));
            });
        },
        async FetchBankDetailsFromSortCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/addresses/fetch/sortcode`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(CoalesceJSON(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchBankDetailsFromSortCode: ${error.message}`));
            });
        },
    },
};

function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
